<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>

        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

import {
  getapplicationlist
} from '@/api/person/person.js'

import { getsysparameterList } from '@/api/system/sys_parameter'

// import {Notification} from 'element-ui';

let moment = require('moment')
export default {

  data () {
    return {
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          align: 'center'
        },

        {
          title: '姓名',
          key: 'Aperid_CN',
          align: 'center',
          sortable: true,
          tooltip: 'true'
        },
        {
          title: '单位',
          key: 'Acomid_CN',
          align: 'center',
          tooltip: 'true',
          sortable: true
        },
        {
          title: '应聘职位',
          key: 'Ajobid_CN',
          align: 'center',
          tooltip: 'true',
          sortable: true
        },
        {
          title: '方式',
          key: 'Atype_CN',
          align: 'center',
          tooltip: 'true',
          sortable: true
        },
        {
          title: '结果',
          key: 'Astate_CN',
          align: 'center',
          tooltip: 'true',
          sortable: true
        },
       {
         title: '联系电话',
         key: 'Pphone',
         align: 'center',
         sortable: true,
         tooltip: 'true'
       },
        {
          title: '应聘时间',
          key: 'Addtime',
          align: 'center',
          tooltip: 'true',
          sortable: true
        }
//        {
//          title: "是否面试",
//          key: "Aneedsee_CN",
//          align: "center",
//          tooltip:"true",
//          sortable: true,
//          width: 120,
//        },
//        {
//          title: "面试房间",
//          key: "Arid_CN",
//          align: "center",
//          tooltip:"true",
//          sortable: true,
//          width: 120,
//        },
//        {
//          title: "面试时长",
//          key: "Isetime",
//          align: "center",
//          tooltip:"true",
//          sortable: true,
//          width: 120,
//        },
        // {
        //   title: '状态',
        //   key: 'handle',
        //   width: 100,
        //   fixed: 'right',
        //   align: 'center',
        //   render: (h, params) => {
        //     return h('div', [
        //       h('Tag', {props: {color: params.row.Jstate_col}}, params.row.Jstate_CN)
        //     ])
        //   }
        // },

      ]
    }
  },
  methods: {

    getapplicationlist (key, value) {
      this.spinShow = true

      getapplicationlist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data
          this.pageTotal = res.data.count
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },

    handleRemove (index) {
      this.formValidate.args_items[index].status = 0
    },

    // table 选中的ID
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.Id)
      })

      this.tableSelectIdList = SelectIdList
    },

    closeModal () {
      this.dialog.show = false
    },

    handleSearch () {
      this.getapplicationlist(this.searchVal)
    },
    // 点击节点
    // 翻页
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getapplicationlist(this.searchVal)
      } else {
        this.getapplicationlist()
      }
    },
    // 切换分页
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getapplicationlist(this.searchVal)
      } else {
        this.getapplicationlist()
      }
    },

    searchinput () {
      if (this.searchVal) {
        this.getapplicationlist(this.searchVal)
      } else {
        this.getapplicationlist()
      }
    }
  },

  watch: {
    searchVal (val) {
      this.searchVal = val
      // this.getServerList(this.searchVal)
    }
  },
  mounted () {
    this.getapplicationlist()
  }
}

</script>

<style lang="less" scoped>
.search-con {
  padding: 10px 0;

  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }

    &-input {
      display: inline-block;
      width: 200px;
      margin-left: 2px;
    }

    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
